
module.exports = {
  // TODO: change your profile information here
  name: "Ahel Das Chatterjee",
  greeting: "Hey 👋",
  greetingDescription: "I'm Ahel Das Chatterjee and I'm a CSE Undergrad at IIEST Shibpur!",
  githubUrl: "https://github.com/Ahel2000",
  linkedinUrl: "https://www.linkedin.com/in/ahel-das-chatterjee-5145131a0/",
  cvLink: "https://drive.google.com/file/d/1x4ICGwEMoosMWdZOn_Qilft1HnaBymue/view?usp=sharing",
};
